export default "/static/assets/mql-white.beff04d1b0f94486dabb1ab63d49f6b9.svg";